import React, { memo } from "react"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
    asterisk: {
        color: '#d32f2f',
        marginLeft: theme.spacing(1/2)
    }
}))

const AsteriskComponent = ({ required }: { required: boolean }) => {
    const classes = useStyles()

    return required ? <span className={classes.asterisk}>*</span> : null
}

export default memo(AsteriskComponent)
